import { SideContentConfirmContent, SideContentProps } from './SideContent.types';

export function SideContentConfirmBeforeClosing({
  customContent: CustomContentComponent,
  ...props
}: SideContentProps<boolean> & { customContent?: SideContentConfirmContent }) {
  return <div {...props}>TODO</div>;
}
